<label #label [style.text-align]="textAlign" [style.width.%]="90">{{numberFomattedText}}</label>